<template>
  <card class="w-100" v-if="isView">
    <h5 slot="header" class="header text-center" style="margin-bottom: 5px">광고상세</h5>
    <el-row :gutter="10">
      <el-col :span="12" class="text-center">
        <img v-bind:src="'/api/common/media/' + this.advertisementSeq" style="width: 380px" />
      </el-col>
      <el-col :span="12" class="text-center1">
        <map-component ref="detailMap" :width="380" :read-only="true" :media-type="mediaType" :store-seq="storeSeq" :store-floor-seq="storeFloorSeq"></map-component>
      </el-col>
    </el-row>
    <div class="row" style="margin-top: 10px;">
      <div class="col-lg-4 col-md-4 col-sm-4" v-for="column in detailColumn">
        <stats-card :small-title="column.name"
                    :title="getDetailValueByKey(column.id)"
                    :type="getDetailType(column.id)"
                    :unit="getDetailUnit(column.id)">
        </stats-card>
      </div>
    </div>
    <div class="card-footer text-right">
      <el-button @click.prevent="close()">닫기</el-button>
    </div>
  </card>
</template>

<script>
    import Vue from 'vue'
    import {Button, Row, Col, Checkbox, Card} from 'element-ui'
    import MapComponent from "../Common/MapComponent";
    import StatsCard from 'src/components/UIComponents/Cards/StatsCard';
    import ColumnSettingProxy from "@/proxies/ColumnSettingProxy";

    Vue.use(Button)
    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Checkbox)
    Vue.use(Card)

    export default {
        name: "AdvertisementDetailComponent",
        created: function () {
            new ColumnSettingProxy()
                .findAllByUserIdAndPageType(this.pageType)
                .then((response) => {
                    this.columns = response.columnSettings;
                    this.isView = true;
                });
        },
        props: {
            mediaType: String,
            storeSeq: Number,
            storeFloorSeq: Number,
            advertisementSeq: Number,
            pageType: String,
            selectedRow: Object,
        },
        components: {
            MapComponent,
            StatsCard,
        },
        computed: {
            detailColumn() {
                return this.columns.filter(function (c) {
                    return c.show && c.id !== 'image';
                })
            },
        },
        methods: {
            close() {
                window.close();
            },
            getDetailValueByKey(key) {
                let v = this.selectedRow[key];
                switch (key) {
                    case "media_type":
                        v = Vue.getMediaType(this.selectedRow['media_type']);
                        break;
                    case "is_light":
                        v = Vue.getIsLight(v);
                        break;
                    case "floor":
                        v = this.selectedRow['floor_type'] === 'F' ? v + this.selectedRow['floor_type'] : this.selectedRow['floor_type'] + v;
                        break;
                    case "position_number":
                        v = v + this.selectedRow['position_code'];
                        break;
                    case "profit":
                        v = this.selectedRow['profit_text']
                        break;
                    case "billing_type":
                        v = Vue.getBillingType(this.selectedRow['profit_text']);
                        break;
                    case "prepayment_price":
                    case "installment_price":
                        if(v === 0) {
                          v = "-";
                        }
                        break;
                    case "month":
                        if(v === 0) {
                          v = "-";
                        }
                        break;
                    default:
                        if(v === undefined || v === "") {
                          v = "-";
                        }
                        break;
                }
                return v;
            },
            getDetailType(key) {
                let v = "string";
                let value = this.selectedRow[key];
                switch (key) {
                    case "width":
                    case "height":
                        v = "number";
                        break;
                    case "prepayment_price":
                    case "installment_price":
                        if(value !== 0) {
                          v = "number";
                        }
                        break;
                }
                return v;
            },
            getDetailUnit(key) {
                let value = this.selectedRow[key];
                let v = "";
                switch (key) {
                    case "width":
                    case "height":
                        v = "mm";
                        break;
                    case "prepayment_price":
                    case "installment_price":
                        if(value === 0) {
                          v = "";
                        } else {
                          v = "원";
                        }
                        break;
                    case "duration":
                        v = "초";
                        break;
                }
                return v;
            },
        },
        data() {
            return {
                columns: [],
                isView: false,
            }
        }
    }
</script>

<style scoped>

</style>
